import AlertMessage from "../../../atoms/AlertMessage";
import React from "react";

const StartEditingAlertMessage = () => <AlertMessage>
    <p className="mb-0">Start editing your Course Information in order to add an available course.</p>
</AlertMessage>;

export default StartEditingAlertMessage;
